module.exports = __webpack_public_path__ + "static/img/menuprd1.7493b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/menuprd1.png
// module id = TOhh
// module chunks = 8